import { useUserStore } from "../store/userStore";
import {
  TRUCK_YARD_ADMIN_ROLE_ID,
  TRUCK_YARD_YARD_ADMIN_ROLE_ID,
  PTAR_COMPANY_ID,
} from "./useTruckYardRole";

export const MONITOR_ROLE_ID = "5oeO2DJfQSLFZ9nKwp73";

export function useIsMonitor() {
  const user = useUserStore((state) => state.user);

  const devices = user?.available_devices;

  const userRoleId = user?.role_id || localStorage.getItem("userRoleId") || "";
  const isMonitor = userRoleId
    ? userRoleId === MONITOR_ROLE_ID
    : localStorage.getItem("userRole") === "monitor";
  const userCompanyId =
    user?.company_id ||
    localStorage.getItem("userCompanyId") ||
    localStorage.getItem("companyId") ||
    "";
  /**
   * Sólo lectura en las pantallas que sí exponen botones de escritura a un rol
   * de PTAR: Admin Flotilla y —la que importa— Facturación → Usuarios.
   *
   * El admin de patios está acá desde #558 y no es simetría decorativa.
   * `/facturacion` NO tiene guard de ruta (router/config.tsx:544 monta
   * `FacturacionLayout` sin `RoleProtectedRoute`): el sidebar de PTAR sólo le
   * oculta la categoría, así que se llega escribiendo la URL. Y esa pantalla es
   * exactamente donde se asigna el rol de un usuario, listando `roles` entero
   * sin filtrar — que es como el rol "yard admin" llegó a 5 usuarios de
   * producción sin pasar por ningún código.
   *
   * Lo que esto cierra y lo que NO, dicho con precisión porque la diferencia
   * importa: esto saca los BOTONES de escritura, o sea la escalada de un clic
   * desde el producto. NO cierra la escalada. `PUT /user` está guardado sólo
   * por `validateToken` + `validateActiveSession` + `requireWriteScope`, y
   * `requireScopes` (middlewares/validateScopes.js:15) hace `return next()`
   * para todo lo que no sea un `api_token`; en `usersController.putUser` el
   * chequeo de autorización está literalmente COMENTADO ("Autorización básica:
   * solo auto-edición por ahora") y `role_id` se escribe tal cual venga. O sea
   * que un `PUT /user` a mano con `role_id: "HiLYcf6ndou53xpXNJ02"` sigue
   * convirtiendo a cualquiera en admin de compañía, admin de patios incluido.
   * Cerrarlo va del lado del servidor y en su propia issue; esto es la mitad de
   * la UI y hay que leerlo así.
   */
  const isReadOnly =
    (userRoleId === TRUCK_YARD_ADMIN_ROLE_ID ||
      userRoleId === TRUCK_YARD_YARD_ADMIN_ROLE_ID) &&
    userCompanyId === PTAR_COMPANY_ID;

  return {
    isMonitor,
    isReadOnly,
    canEdit: isMonitor,
    isDisabled: !isMonitor,
    devices,
  };
}

export default useIsMonitor;
